import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import Survey from './views/containers/Survey/Survey';
import Portal from './views/components/Portal/Portal';
// import Favicon from 'react-favicon';

import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import LoadingIndicator from './utilities/LoadingIndicator';

import { loadingSpinner } from './actions/SurveyAction';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      load:true,
      extendLoad:true,
      unAnsweredPage:null,
      
    }
    this.showFirstTime = true
  }

  componentDidMount(props) {
    this.props.dispatch(loadingSpinner(true));
     this.interval = setTimeout(() => {
        this.setState({load:false});
     
    }, 1750);
    const urlParams1 = new URLSearchParams(window.location.search);
    const urlSpinnerBgColor = urlParams1.get('bg') || 'white'; // Default to white if not present
    const urlSpinnerColor = urlParams1.get('c') || 'gray';

    const spinnerElements = document.querySelectorAll('.css-df17o1, .css-1r098pj, .css-1pghxvk');
    spinnerElements.forEach(element => {
      element.style.setProperty('background', urlSpinnerBgColor, 'important');
      if (urlSpinnerColor) {
        element.style.setProperty('color', urlSpinnerColor, 'important');
      }
    });

  }
    render() {
     
    return (
      <div className="App">
        <LoadingIndicator active={this.state.load} />
        <Switch>
          <Route path="/" exact component={Portal} />
          <Route path="/survey/:formXmlGuid/:dataCollectionGuid/:authorizationTokenGuid" exact component={Survey}/>
        </Switch> 
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoader:state.survey.isLoader,
  surveyList:state.survey.surveyList
});

export default connect(mapStateToProps)(App);
